import React from 'react';
import { Wrench } from 'lucide-react';

export default function MaintenanceMode() {
  return (
    <div className="min-h-screen bg-black grain-texture flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        
        {/* Icon */}
        <div className="mb-6 flex justify-center">
          <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-orange-500 to-orange-600 flex items-center justify-center glow-orange">
            <Wrench className="w-10 h-10 text-white" />
          </div>
        </div>
        
        {/* Heading */}
        <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">
          Wartungsarbeiten
        </h1>
        
        {/* Message */}
        <p className="text-white/70 text-lg leading-relaxed mb-6">
          SNAPSHOT ist vorübergehend nicht verfügbar.
        </p>
        
        <p className="text-white/50 text-sm">
          Wir arbeiten daran, dir das beste Erlebnis zu bieten.<br/>
          Bitte versuche es in Kürze erneut.
        </p>
        
        {/* Ambient Glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-orange-500 opacity-5 blur-3xl rounded-full pointer-events-none"></div>
        
      </div>
    </div>
  );
}
